import React from 'react';
import PropTypes from 'prop-types';
import {Nav, Navbar} from "react-bootstrap";
import {Link, NavLink} from "react-router-dom";
import APP_VERSION from "../../version";
import { getCurrentSchoolYearStartYear } from "../common/schoolYear";
import { buildManageRouteWithSchoolYear } from "./manageSchoolYearRouting";
import SchoolYearSelector from "./SchoolYearSelector";

const getItemIcon = item => item.icon || "far fa-circle";

function ManageNav({
  items,
  brandName,
  signOut,
  currentSearch,
  activeSchoolYearStartYear,
  schoolYearOptions,
  onActiveSchoolYearChange,
  settingsRoute,
  permissionsRoute,
  canSwitchContext,
  onSwitchContext,
  contextSwitching,
}) {
  return (
    <Navbar collapseOnSelect expand="lg" id="nav" className="manage-custom-nav fixed-top px-4 py-1 shadow-sm">
      <Navbar.Brand as={Link} to="/" className="manage-custom-nav-brand p-1">
        <img
          src="../../resources/app/manage-logo.png"
          width="52px"
          height="52px"
          className="manage-custom-nav-logo"
          alt=""
        />
        <span className="manage-custom-nav-brand-text">{brandName}</span>
      </Navbar.Brand>
      {!contextSwitching && (
        <>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="manage-custom-nav-items mr-auto">
              {items.map(item => (
                <Nav.Link
                  as={NavLink}
                  exact={item.exact || item.route === "/manage/"}
                  activeClassName="active"
                  eventKey={item.name}
                  key={item.name}
                  to={buildManageRouteWithSchoolYear(item.route, currentSearch, activeSchoolYearStartYear)}
                  className="manage-custom-nav-link ml-1 my-0"
                >
                  <i className={`${getItemIcon(item)} manage-custom-nav-link-icon`} />
                  {item.name}
                </Nav.Link>
              ))}
            </Nav>
            <Nav className="manage-custom-nav-meta align-items-lg-center ml-lg-2">
              <Navbar.Text className="manage-version-label ml-1 mr-lg-3 my-0">
                {APP_VERSION}
              </Navbar.Text>
              <div className="manage-school-year-selector-wrapper mr-lg-3 my-2 my-lg-0">
                <SchoolYearSelector
                  activeSchoolYearStartYear={activeSchoolYearStartYear}
                  options={schoolYearOptions}
                  onChange={onActiveSchoolYearChange}
                />
              </div>
              {permissionsRoute && (
                <Nav.Link
                  as={NavLink}
                  exact
                  activeClassName="active"
                  eventKey="Uprawnienia"
                  to={buildManageRouteWithSchoolYear(permissionsRoute, currentSearch, activeSchoolYearStartYear)}
                  title="Uprawnienia"
                  aria-label="Uprawnienia"
                  className="manage-custom-nav-link ml-1 my-0"
                >
                  <i className="fas fa-user-shield fa-lg manage-custom-nav-link-icon" />
                  <span className="manage-nav-action-label">Uprawnienia</span>
                </Nav.Link>
              )}
              {settingsRoute && (
                <Nav.Link
                  as={NavLink}
                  exact
                  activeClassName="active"
                  eventKey="Ustawienia"
                  to={buildManageRouteWithSchoolYear(settingsRoute, currentSearch, activeSchoolYearStartYear)}
                  title="Ustawienia"
                  aria-label="Ustawienia"
                  className="manage-custom-nav-link ml-1 my-0"
                >
                  <i className="fas fa-cog fa-lg manage-custom-nav-link-icon" />
                  <span className="manage-nav-action-label">Ustawienia</span>
                </Nav.Link>
              )}
              {canSwitchContext && (
                <Nav.Link
                  as="button"
                  type="button"
                  eventKey="Przełącz konto"
                  onClick={onSwitchContext}
                  title="Przełącz konto"
                  aria-label="Przełącz konto"
                  className="manage-custom-nav-link ml-1 my-0 btn btn-link"
                >
                  <i className="fas fa-random fa-lg manage-custom-nav-link-icon" />
                  <span className="manage-nav-action-label">Przełącz konto</span>
                </Nav.Link>
              )}
              <Nav.Link
                as="button"
                type="button"
                eventKey="Wyloguj"
                onClick={signOut}
                title="Wyloguj"
                aria-label="Wyloguj"
                className="manage-custom-nav-link ml-1 my-0 btn btn-link"
              >
                <i className="fas fa-sign-in-alt fa-lg manage-custom-nav-link-icon" />
                <span className="manage-nav-action-label">Wyloguj</span>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </>
      )}
    </Navbar>
  );
}

ManageNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    selected: PropTypes.bool,
    route: PropTypes.string,
    icon: PropTypes.string,
    exact: PropTypes.bool,
    onClick: PropTypes.func,
  })).isRequired,
  signOut: PropTypes.func.isRequired,
  brandName: PropTypes.string,
  currentSearch: PropTypes.string,
  activeSchoolYearStartYear: PropTypes.number,
  schoolYearOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  })),
  onActiveSchoolYearChange: PropTypes.func,
  settingsRoute: PropTypes.string,
  permissionsRoute: PropTypes.string,
  canSwitchContext: PropTypes.bool,
  onSwitchContext: PropTypes.func,
  contextSwitching: PropTypes.bool,
};

ManageNav.defaultProps = {
  currentSearch: "",
  brandName: "Extra English",
  activeSchoolYearStartYear: getCurrentSchoolYearStartYear(),
  schoolYearOptions: [],
  onActiveSchoolYearChange: () => {},
  settingsRoute: null,
  permissionsRoute: null,
  canSwitchContext: false,
  onSwitchContext: () => {},
  contextSwitching: false,
};

export default ManageNav;
